// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32z1Z","toggle":"styles_toggle__QWXxZ","preview":"styles_preview__2KYh7"};